import { useOutletContext } from 'react-router-dom';
import type {
  Address,
  BpOrder,
  BusinessPartnerWithStats,
  SalesPerson,
} from '@/api/business-partner/business-partner.types';
import type { ContactEmployeeWithUser } from '@/api/contact-employee/contact-employee.types';
import { BpOverviewTab } from './bp-overview-tab.component';
import { BpOrdersTab } from './bp-orders-tab.component';
import { BpContactsTab } from './bp-contacts-tab.component';

/** Context provided by {@link BpDetail} to its tab routes. */
export interface BpDetailContext {
  bp: BusinessPartnerWithStats;
  addresses: Address[];
  salesPerson: SalesPerson | null | undefined;
  orders: BpOrder[];
  ordersTotal: number;
  ordersPending: boolean;
  ordersPage: number;
  setOrdersPage: (page: number) => void;
  contacts: ContactEmployeeWithUser[];
  contactsPending: boolean;
}

/** Detail-panel placeholder shown at `/i/business-partners` (no partner selected). */
export function BpDetailEmpty() {
  return (
    <div className="bp-empty">
      <div>
        <div className="big">Kein Partner ausgewählt</div>
        <div>Wähle einen Partner aus der Liste.</div>
      </div>
    </div>
  );
}

export function BpOverviewRoute() {
  const { bp, addresses, salesPerson } = useOutletContext<BpDetailContext>();
  return <BpOverviewTab bp={bp} addresses={addresses} salesPerson={salesPerson} />;
}

export function BpOrdersRoute() {
  const { bp, orders, ordersTotal, ordersPending, ordersPage, setOrdersPage } =
    useOutletContext<BpDetailContext>();
  return (
    <BpOrdersTab
      businessPartnerId={bp.id}
      orders={orders}
      total={ordersTotal}
      isPending={ordersPending}
      page={ordersPage}
      setPage={setOrdersPage}
    />
  );
}

export function BpContactsRoute() {
  const { contacts, contactsPending } = useOutletContext<BpDetailContext>();
  return <BpContactsTab contacts={contacts} isPending={contactsPending} />;
}
